var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.asset_url,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey,
    isQmod = companyVars.isQmod,
    autorefresh = companyVars.autorefresh;

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// Fires on click or enter keypress
jq.fn.accessibleClick = function (handler) {
    jq(this).on('click keyup', function (event) {
        if (event.type === 'keyup') {
            var code = event.which;
            // Don't consider it a click if we don't press enter or spacebar
            if ((code !== 32) && (code !== 13)) {
                return false;
            }
        }
        handler.call(this, event);
    });
};
    
var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad () {
    // Add hcaptcha to all forms on a page
     jq('.h-captcha').each(function () {
        var form = jq(this).closest('form');
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "callback": function (token) {
                jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    });
    validate_forms();
}

function validate_forms() {
    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr('id');
        jq(this).validate({
            errorElement: "span",
            errorClass: "error eq-error",
            rules: {
                password_confirm: {
                    equalTo: "#password"
                }
            },
            messages: {
                password_confirm: {
                    equalTo: "Passwords must be the same"
                }
            },
            errorPlacement: function (error, element) {
                if (element.attr("type") == "radio") {
                    error.prependTo(element.parent());
                } else {
                    error.appendTo(element.parent());
                }
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            },
            // Scroll and focus on the 1st error input after submitting an invalid form 
            invalidHandler: function(event, validator) {
                if (validator.errorList.length >= 1) {
                    let errorElement = validator.errorList[0].element;
                    errorElement.scrollIntoView({ behavior: 'instant', block: 'center' });
                    errorElement.focus();
                }
            }
        });
    });
}

// Main document ready scripts
jq(document).ready(function () {
    // Pagination
    const paginationMobile = jq('#pagination--mobile');
    if (paginationMobile.length) {
        jq(this).find('#pagination--mobile-select').change(function() {
            var selectedPage = jq(this).val();
            location.href = encodeURI(selectedPage);
        });
    }

    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr('rel');
        if (!linkRel || (linkRel && linkRel.indexOf('noopener') == -1)) {
            var newRel = linkRel === undefined ? '' : linkRel;
            newRel += linkRel && linkRel.length ? ' noopener' : 'noopener';
            jq(this).attr('rel', newRel);
        }
        // Add descriptive aria-label for screen readers if there's not already a title or aria-label attr set
        if (this.getAttribute('title') === null && this.getAttribute('aria-label') === null && !jq(this).hasClass('headline-link')) {
            this.setAttribute('aria-label', this.innerText + ' Opens in a new window');
        }
    });
    addRequiredAsteriskToLabels();
    
    // Scroll more home hero button
    var scrollMore = document.getElementById("scroll-more");
    var mainContent = document.getElementById("mainContent");

    if (!mainContent && scrollMore) {
        scrollMore.style.display = "none";
    } else if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();

            // make scroll distance larger for mobile devices, when the navigation bar is not in a fixed position
            let header = document.querySelector("#header");
            var animationDistance = (window.innerWidth <= 991 && header && window.getComputedStyle(header).getPropertyValue("position") !== "fixed") ? 0 : jq("#header").outerHeight();
            jq("html, body").animate({
                scrollTop: jq(mainContent).offset().top - animationDistance
            }, "slow");
        });
    }

    jq("#header.affixed").affix({
        offset:{
            top: 1
        }
    });
    
    //Video Play/Pause Buttons
    var videoBtns = document.querySelectorAll('.video-control-btn');
    videoBtns.forEach(function(el) {
        // get video id from attribute 'data-target'
        var targetVideo = document.getElementById(el.dataset.target);
        if (targetVideo) {
          jq(el).click(function(e) {
            if (targetVideo.paused) {
              targetVideo.play();
              //Controls don't show by default to match designs
              //On play, we need to hide the designed play/pause button and shows the controls
              if (targetVideo.classList.contains('show-controls-on-play')) {
                el.classList.add('hide');  
                targetVideo.setAttribute('controls', '');
              }
              el.setAttribute('aria-label', 'Pause Video');
            } else {
              targetVideo.pause();
              el.setAttribute('aria-label', 'Play Video');
            }
            el.classList.toggle('paused');
          });
        }
    });
    
    //Circle Stat with Percentage Animation
    var divPercentage = jq(".stats-row-w-percents");
    if(divPercentage.length) {
        jq(document).bind("scroll", function (ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq(".stats-row-w-percents").offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq(".stats-row-w-percents .stat").each(function () {
                    var percDiv = jq(this).find(".number"),
                    svgElm = jq(this).find(".circle"),
                    percentNumber = jq(this).attr("data-percent");
                    svgElm.attr("stroke-dasharray", percentNumber + ", 100");
                    svgElm.addClass("active");
                    jq({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + "%");
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                jq(document).unbind("scroll");
            }
        });
    }
    
    var subNav = jq(".sub-navigation.affixed");
    if(subNav.length) {
        jq(subNav).affix({
            offset: { 
                top: jq(".sub-navigation").offset().top - jq("#header").outerHeight()
            }
        });
    }

    var menuRight = document.getElementById("mobile-nav"),
    showRight = document.getElementById("showRight");
    
    jq.fn.openMobileRightMenu = function() {
        toggleMenuKeybind();
        jq(".mobile-nav-trigger").toggleClass("active");
        jq("body").toggleClass("push-to-left");
        jq(menuRight).toggleClass("cbp-spmenu-open");
        disableOther("showRight");
        if (jq(".mobile-nav-trigger").hasClass('active')) {
            jq('.mobile-nav-trigger').attr('aria-label', 'Close main navigation');
            jq('.mobile-nav-trigger').attr('aria-expanded', 'true');
        } else {
            jq('.mobile-nav-trigger').attr('aria-label', 'Expand main navigation');
            jq('.mobile-nav-trigger').attr('aria-expanded', 'false');
        }
    }
    
    
    // Disable menu toggle when a link is clicked
    jq(".main-menu a").on("click", function () {
        if (jq(".mobile-nav-trigger").hasClass("active")) {
            jq(".mobile-nav-trigger").removeClass("active");
            jq("body").removeClass("push-to-left");
            jq(menuRight).removeClass("cbp-spmenu-open");
        }
    });

    function disableOther(button) {
        if (button !== "showRight") {
            jq(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
     function toggleMenuKeybind() {
        var $body = jq('body');    
        if ($body.hasClass('push-to-left')) {
            $body.off("keydown");
        } else {
            $body.on("keydown", function (e) {
                if (e.which == 27) {
                    jq(".main-nav").toggleClass("active");
                    jq(showRight).toggleClass('active');
                    jq("body").toggleClass("push-to-left");
                    jq(menuRight).toggleClass("cbp-spmenu-open");
                    disableOther("showRight");
                    $body.off("keydown");
                }
            });
        }
    }

    // Basic Form Validation
    validate_forms();
    
    jq.validator.methods.email = function (value, element) {
      return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    }
    
    //File input
    var fileInput = jq(".file-text input");
    fileInput.change(function (e){
        $this = jq(this);
        var val = $this.val().split("\\");
        var length = val.length;
        var filename = val[length-1];
        jq(this).parent(".file-text").children(".text-wrapper").text(filename);
    });

    // SEC Filing Filters - auto submit form
    jq("#sec-filing-filter select").on("change", function (e) {
        jq(this).closest("form").submit(); 
    });
    
    var $filterSelect = jq(".row-filter .eq-select");
    if ($filterSelect.length) {
        $filterSelect.on("change", function () {
            var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            var query = "";
            jq(".row-filter .eq-select").each(function () {
                var prefix = "&";
                if (query.length === 0) {
                    prefix = "?";
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr("name") + "=" + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
            	var full_url = url + "?year=" + jq(this).val();
            	if (window.location.href != full_url) {
            		window.location.href = full_url;
            	}
            } else {
            	if (window.location.href != url) {
            		window.location.href = url;
            	}
            }
       });
    }
    
    // Resources module
    if (jq(".module-resources-page").length) {
        var viewModel = new ViewModel(JSON.parse(document.getElementById("resourcesVm").innerText));
    }
    
    // News slider
    if (jq(".news-slider").length) {
        jq(".news-slider").slick(JSON.parse(document.getElementById("newsSlickOptions").innerText));
    }
    // Quote slider CTA
    if (jq(".quote-slider-cta").length) {       
        jq(".quote-slider-cta").slick({
            "infinite": true,
            "dots": true,
            "arrows": false,
            "appendDots": ".slider-nav", 
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "autoplay": true,
            "autoplaySpeed": 2000,
            "fade": true,
            "speed": 600,
            "cssEase": "linear"
        });

        jq('.btn-control-slider').on('click', function () {
            if (jq(this).hasClass('btn-play')) {
                jq(this).removeClass('btn-play');
                jq(this).addClass('btn-pause');
                jq(this).attr('aria-label', 'Pause slider');
                jq('.quote-slider-cta').slick('slickPlay');
            } else {
                jq(this).removeClass('btn-pause');
                jq(this).addClass('btn-play');
                jq(this).attr('aria-label', 'Play slider');
                jq('.quote-slider-cta').slick('slickPause');
            } 
        });

        var qsSlider = jq('.quote-slider-cta');
        var qsDotList = jq('.quotes-cta .slider-nav .slick-dots');

        function qsApplyTabs() {
            qsDotList.attr('role', 'tablist').attr('aria-label', 'Testimonials');
            var $tabs = qsDotList.find('li button');
            var count = $tabs.length;
            $tabs.each(function (i) {
                var $b = jq(this);
                var active = $b.parent().hasClass('slick-active');
                $b.attr('role', 'tab');
                $b.attr('aria-label', 'Slide ' + (i + 1) + ' of ' + count);
                $b.attr('aria-selected', active ? 'true' : 'false');
                $b.attr('tabindex', active ? '0' : '-1');
                $b.removeAttr('aria-expanded');
                $b.html('');
                $b.parent().attr('role', 'presentation');
                var controls = $b.attr('aria-controls');
                if (controls) {
                    jq('#' + controls)
                        .attr('aria-labelledby', $b.attr('id'))
                        .attr('aria-roledescription', 'slide');
                }
            });
        }

        qsApplyTabs();
        qsSlider.on('afterChange', function () { qsApplyTabs(); });

        qsDotList.on('keydown', 'button[role="tab"]', function (e) {
            var $tabs = qsDotList.find('li button');
            var idx = $tabs.index(this);
            var last = $tabs.length - 1;
            var target;
            switch (e.which) {
                case 37: case 38: target = idx <= 0 ? last : idx - 1; break;
                case 39: case 40: target = idx >= last ? 0 : idx + 1; break;
                case 36: target = 0; break;
                case 35: target = last; break;
                default: return;
            }
            e.preventDefault();
            qsSlider.slick('slickGoTo', target);
            $tabs.attr('aria-selected', 'false').attr('tabindex', '-1');
            $tabs.eq(target).attr('aria-selected', 'true').attr('tabindex', '0').focus();
        });
    }

    // SEC Filings expand
    jq(".spr-expandable").hide();
    jq(".spr-toggle-expandable").click(function () {
    	jq(this).next(".spr-expandable").toggle("blind");
    	jq(this).toggleClass('expanded');
    	if (jq(this).hasClass('expanded')) {
    	    jq(this).attr('aria-pressed', true);   
    	} else {
    	    jq(this).attr('aria-pressed', false);
    	}
    });
    
    // Crisis Messaging
    var $majorAnnouncement = jq('#majorAnnouncement');
    var majorAnnouncementCookieName = "eqMajorAnnouncement";
    if ($majorAnnouncement.length) {
        var majorAnnouncementTimestamp = $majorAnnouncement.data("timestamp");
        var majorAnnouncementCookie = Cookies.get(majorAnnouncementCookieName);
        if (majorAnnouncementCookie != majorAnnouncementTimestamp) {
            let announcements = new EqDialog({
                show_close_button: true,
            });
            announcements.open('inline', 'majorAnnouncement');
            // Expires should be set to a number of days
            Cookies.set(majorAnnouncementCookieName, majorAnnouncementTimestamp, { secure: true, domain: window.location.hostname, expires: 7 });
        }
    }
    
    // Add Class to body if there is a scoll bar in the page
    if (jq(document).width() < jq(window).outerWidth()) { 
        jq('body').addClass('scrollbar');
    }
    
    function resize_events() {
        // Fix accessibility issue for main navigation and sub navigation triggers on mobile
        if (window.innerWidth <= 991) {
            jq('.mobile-nav-trigger').attr('tabindex', 0);
            jq('.mobile-sub-nav-trigger').attr('tabindex', 0);
            jq('.has-children ul li a').attr('tabindex', '-1');
            jq('.cbp-spmenu > .main-menu ul').attr('aria-hidden', 'true');
            jq('.has-children ul').attr('aria-hidden', 'true');
            jq('.cbp-spmenu > .main-menu > li > ul').attr('aria-hidden', 'true');
            if (jq('.cbp-spmenu').hasClass('cbp-spmenu-open')) {
                jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', 0);
            } else {
                jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', -1);
            }
        } else {
            jq('.mobile-nav-trigger').attr('tabindex', '');
            jq('.mobile-sub-nav-trigger').attr('tabindex', '');
            jq('.has-children ul li a').attr('tabindex', '');
            jq('.has-children ul').attr('aria-hidden', 'false');
            jq('.cbp-spmenu > .main-menu > li > ul').attr('aria-hidden', 'false');
            jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', 0);
        }
        // Add scroll to tables that would get out of bounds and update shadows as needed
        applyScrollToTables();
        jq(".scroll .table-figure").on("scroll", updateShadowsInTables);
        updateShadowsInTables();
    }
    // Wrap article news in table-wrapper to prevent it from breaking on mobile
    jq(".full-news-article table").each(function (ind) {
        let title = "News article table " + (ind + 1);
        jq(this).wrap(`<div class="table-wrapper"></div>`);
        jq(this).attr("aria-label", title);
    });
    jq(".financials table").each(function (ind) {
        let title = "Financials table " + (ind + 1);
        jq(this).wrap(`<div class="table-wrapper"></div>`);
        jq(this).attr("aria-label", title);
    });
    // Add elements to table wrappers for mobile styling
    jq("table").each(function () {
        let wrap = jq(this).closest(".table-wrapper");

        wrap.prepend('<span class="mobile-note">Scroll to view <span aria-hidden="true" class="scroll-arrow"></span></span><span class="left-shadow-block"></span>');
        wrap.append('<span class="right-shadow-block"></span>');
    });
    // Call resize_events() on load
    resize_events();

    jq(window).resize(function(evt) {
        resize_events();
    });
    
    // Enable accessible clicking on mobile navs and subnavs
    jq('.mobile-nav-trigger').on('click', function(evt) {
        evt.stopPropagation();
        jq(this).openMobileRightMenu();
        resize_events();
        return false;
    });
    // Close mobile nav when selecting the darkened body background
    jq('.cbp-spmenu').accessibleClick(function(evt) {
        evt.stopPropagation();
    });
    jq('body').on('click', function(evt) {
        if (this.classList.contains("push-to-left") ) {
            jq(this).openMobileRightMenu();
            resize_events();
            return false;
        };
    }); 
    
    // Detect window size change (switching to landscape on tablet
    var windowW = window.innerWidth;
    jq(window).resize(function() {
        windowW = window.innerWidth;
    });
    
    // Close mobile nav after selecting anchor link, make selected link use active class
    jq('.main-menu > .has-children > a').accessibleClick(function(e) {
        if (windowW >= 992) return;
        // Remove any existing active classes
        if (this.parentElement.classList.contains('active')) {
            this.parentElement.classList.remove('active');
            return;
        }
        jq('.main-menu > .has-children').each(function() {
            this.classList.remove('active');
        });
        this.parentElement.classList.add('active');
    });
    
    jq('#mobile-nav ul a').accessibleClick(function(e) {
        if (windowW >= 992) return;
        let navMenu = document.getElementById('mobile-nav');
        jq('#mobile-nav').toggleClass('cbp-spmenu-open');
        jq('body').toggleClass('push-to-left');
        jq('#showRight').toggleClass('active');
    });    

    var accessibleClickSelectors = [
        '.mobile-sub-nav-trigger',
        '.quarterly-results [role=button]'
    ];

    jq(accessibleClickSelectors.join(',')).accessibleClick(function(evt) {
        // Use accessibleClick to normalize key/mouse handling
        if (evt.type !== 'click') {
            jq(this).click();
            return false;
        }
    });
    
    //Expand/Collapse all button for Financial Results
    var FinancialResultsExpandBtn = jq(".expand-all-quarters");
    var QuarterHeaders = jq(".quarterly-results .header");
    
    FinancialResultsExpandBtn.on('click', function(e) {
        //If elements are collapsed, expand the rest
        if (jq(this).text() == 'Expand All') {
            QuarterHeaders.filter(".collapsed").click();
        } else {
            //Otherwise collapse them all
            QuarterHeaders.filter(":not(collapsed)").click();
        }
    });
    
    QuarterHeaders.on("click", function(e) {
        if (FinancialResultsExpandBtn.length) {
            //Allow for collapse animation to complete
            //setTimeout(functionRef, delay, param1, param2)
            setTimeout(updateExpandBtnText, 200, FinancialResultsExpandBtn, ".quarterly-results .header");
        }
    });
    
    // Allows upload of cover letter via styled link by triggering hidden upload/input field
    jq("#cover_letter").on('click', function(e) {
        e.preventDefault();
        jq("#upload_cover_letter:hidden").trigger('click');
    });

    /**
     * Elastic Search Tab Control
     **/
    const delay = 1000; // Time in milliseconds to wait before selecting tab

    // Get current URL
    let currentUrl = window.location.href;
    
    // Defining Active Tab variable
    let tabTarget;
    if (currentUrl.includes("press-releases")) {
        tabTarget = '#tab-press-releases';
    } else if (currentUrl.includes("sec-filings")) {
        tabTarget = '#tab-all-sec-filings';
    } else {
        tabTarget = '#tab-all';
    }
    
    // Execute click
    function selectTab() {
        setTimeout(() => {
            if ( jq(tabTarget).length ) {                                       
               jq(tabTarget).click();               
            }
        }, delay); 
    }    
    selectTab();
    
    // Chart Library Functionality
    jq(".chart-table-expander").on('click', function(e) {
        e.target.classList.toggle('hidden');
        e.target.parentElement.querySelector('.chart-legend').classList.toggle('hidden');
    });
   
   // Remove width from table headers with only a superscript  
    jq(".report .th").each(function(){
        // Extract the innerHTML
        const innerContent = jq(this).html().trim();
        
        // Use a regex to check if content matches <sup> with a number, asterisk, or these wrapped in square brackets
        const regex = /^<sup>(\[\d+\]|\d+|\[\*\]|\*)<\/sup>$/;
        if (regex.test(innerContent)) {
            jq(this).css({
                "width": "0%",
                "padding-left": "0"
            });
        }
    });
    
    /**
     * Accessibility Fix for Radio Inputs
     **/
    let radioLabels = document.querySelectorAll('.eq-radio label');

    radioLabels.forEach(function(radioLabel) {
        radioLabel.setAttribute('tabindex', '0'); // Ensure labels are focusable

        radioLabel.addEventListener('keydown', function(e) {
            // Check if the key pressed is the spacebar
            if (e.key === ' ' || e.keyCode === 32) {
                e.preventDefault();
                let associatedRadio = document.getElementById(this.getAttribute('for'));
                // Check if the associated radio button exists and is not already checked
                if (associatedRadio && !associatedRadio.checked) {
                    associatedRadio.checked = true;
                    associatedRadio.dispatchEvent(new Event('change'));
                }
            }
        });
    });
    // MOBILE MENU TRAP FOCUS
    let lastNavItem = jq('.main-menu > li:last-child > a');
    let mobileTrigger = jq('.mobile-nav-trigger');
    // Normal Tab 
    lastNavItem.on('keydown', function(e) {
        if (!e.shiftKey && e.key === 'Tab' && mobileTrigger.hasClass('active')) {
            e.preventDefault();
            mobileTrigger.focus();
        }
    });
    // Shift + Tab
    mobileTrigger.on('keydown', function(e) {
        if (e.shiftKey && e.key === 'Tab' && mobileTrigger.hasClass('active')) {
            e.preventDefault();
            lastNavItem.focus();
        }
    });
    //CCPA Request Form
    jq('#ccpa-request-form input[name="claim"]').change(function(){
        let value = jq(this).val();
        if (value == 'Resident') {
            jq('.show-resident').removeClass('hide');
            jq('.show-representative').addClass('hide');
            jq('#certify_resident').addClass('required');
            jq('#certify_resident').attr('aria-required', 'true');
            jq('.show-representative .conditional-required, #certify_representative').removeClass('required');
            jq('.show-representative .conditional-required, #certify_representative').removeClass('error');
            jq('.show-representative .conditional-required, #certify_representative').removeAttr('aria-required');
        } else if (value == 'Representative') {
            jq('.show-representative').removeClass('hide');
            jq('.show-resident').addClass('hide');
            jq('#certify_resident').removeClass('required');
            jq('#certify_resident').removeClass('error');
            jq('#certify_resident').removeAttr('aria-required');
            jq('.show-representative .conditional-required, #certify_representative').addClass('required');
            jq('.show-representative .conditional-required, #certify_representative').attr('aria-required', 'true');
        }
    });

    if (autorefresh) {
        setTimeout(() => {
            location.reload();
        }, 60000); // Auto reload every minute
    }

    
    // Initialize dialogs
    let eq_dialogs = new EqDialog();
    eq_dialogs.init();
}); // end document.ready

// Function to check if an element is in the viewport
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required").siblings("label").each(function () {
        let currentText = jq(this).text();
        jq(this).text(currentText + "*");
    });
}

/**
 * addCustomErrorFormHandlers
 *
 * Sets up custom error handling for forms, specifically targeting required 
 * checkboxes and radio button groups. Displays error messages and applies
 * border styling to elements that fail validation. Enhances accessibility by
 * updating ARIA attributes based on user interactions.
 *
 * - Applies different border colors for elements within dark-themed sections.
 * - Adds or removes error messages and styles based on validation results.
 * - Updates ARIA attributes for better accessibility.
 */

function addCustomErrorFormHandlers() {
    const BORDER_COLOR_LIGHT = "#D40033";
    const BORDER_COLOR_DARK = "#FA003A";

    // Listen for form submission
    jq("form").on("submit", function (e) {
        jq("ul.checkboxes.required, ul.radios.required").each(function () {
            let type = jq(this).hasClass("checkboxes") ? "checkbox" : "radio";
            let borderColor = jq(this).closest(".dark").length > 0 ? BORDER_COLOR_DARK : BORDER_COLOR_LIGHT;

            // Check if any input of the correct type in this group is checked
            if (jq(this).find('input[type="' + type + '"]:checked').length === 0) {
                jq(this).css("border", "1px solid " + borderColor);

                // Link error to checkbox/radio group
                let errorId = jq(this).parent().attr("aria-labelledby") + "-error";
                jq(this).parent().attr("aria-describedby", errorId);

                // Add error message if it does not already exist
                if (jq(this).siblings(".eq-error").length === 0) {
                    jq(this).after(`<span class="eq-error" id="${errorId}">This field is required</span>`);
                }
            } else {
                // Remove the border and error message if any input is checked
                jq(this).css("border", "");
                jq(this).siblings(".eq-error").remove();
                jq(this).parent().removeAttr("aria-describedby");
            }
        });
    });

    // Event handler for changes to checkboxes and radio buttons in all groups
    jq(document).on("change", 'ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]', function () {
        let ul = jq(this).closest("ul.checkboxes, ul.radios");

        // Update ARIA attributes for accessibility
        if (jq(this).attr("type") === "radio") {
            // Set aria-checked for all radio buttons in the group
            ul.find('input[type="radio"]').attr("aria-checked", "false");
            jq(this).attr("aria-checked", "true");
        }

        // Check if any input in this group is checked
        if (ul.find("input:checked").length > 0) {
            // If an input is checked, remove the border and error message
            ul.css("border", "");
            ul.siblings(".eq-error").remove();
        }
    });

    // Initialize ARIA attributes on page load
    jq('ul.radios input[type="radio"]').each(function () {
        jq(this).attr("aria-checked", this.checked);
    });
}

// Call the function to setup event handlers once the document is ready
jq(document).ready(function() {
    addCustomErrorFormHandlers();
});


//Check if any target elements are collapsed
function elementsAreCollapsed(selector = "[data-toggle='collapse']") {
    if (jq(selector + '.collapsed').length) {
        return true;
    } else {
        return false;
    }
}

function updateExpandBtnText(btn, collapseTarget) {
    if (!btn) {
        return;
    }
    if (elementsAreCollapsed(collapseTarget)) {
        btn.text('Expand All');
    } else {
        btn.text('Collapse All');
    }
}

// Checkbox Groups - Updated for accessibility
jq('[id^=ir-sec-all]').change(function () {
    const parentCheckbox = jq(this);
    const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");

    if (parentCheckbox.is(":checked")) {
        // Check all children but keep them interactive
        childCheckboxes
            .prop("checked", true)
            .attr('aria-checked', 'true');
        
        // Update parent aria-checked to true
        parentCheckbox.attr('aria-checked', 'true');
    } else {
        // Uncheck all children but keep them interactive
        childCheckboxes
            .prop("checked", false)
            .attr('aria-checked', 'false');
        
        // Update parent aria-checked to false
        parentCheckbox.attr('aria-checked', 'false');
    }
});

// Auto-update parent state based on child checkboxes
jq(".ir-sec-sub").change(function () {
    const parentCheckbox = jq("#ir-sec-all");
    const childCheckboxes = parentCheckbox.closest('.eq-checkbox').find(".ir-sec-sub");
    
    // Count checked and total checkboxes
    const totalCheckboxes = childCheckboxes.length;
    const checkedCheckboxes = childCheckboxes.filter(':checked').length;
    
    if (checkedCheckboxes === 0) {
        // No children checked - parent is unchecked
        parentCheckbox
            .prop("checked", false)
            .attr('aria-checked', 'false');
    } else if (checkedCheckboxes === totalCheckboxes) {
        // All children checked - parent is checked
        parentCheckbox
            .prop("checked", true)
            .attr('aria-checked', 'true');
    } else {
        // Some children checked - parent is in mixed state
        parentCheckbox
            .prop("checked", false)
            .attr('aria-checked', 'mixed');
    }
    
    // Update aria-checked for the changed checkbox
    jq(this).attr('aria-checked', jq(this).is(':checked') ? 'true' : 'false');
});

// Timeline
var $timelineEl = jq(".module-timeline");
if ($timelineEl.length) {
    var timeline = {
        resizePoints: function () {
            if (jq(window).outerWidth() < 768) return;
            jq(".point-wrapper").each(function () {
                  var point = jq(this).find(".point");
                  jq(this).css("height", point.outerHeight()/1.2);
                });
        }
    };
    // Once we"re done resizing, calculate the height for the points.
    var resizeTimer;
    jq(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(timeline.resizePoints, 250);
    });
    timeline.resizePoints();
}
//Add Class to body if page has scrollbar
jq(window).on("resize", function (e) {
    if (jq(document).width() < jq(window).outerWidth()) { 
        jq('body').addClass('scrollbar');
    } else {
        jq('body').removeClass('scrollbar');
    }
});
// Scroll More CTA templates
var scrollMore = document.getElementById("scroll-more-alt");
if (scrollMore) {
    jq(scrollMore).accessibleClick(function (e) {
        e.preventDefault();
        var target = jq("#scroll-more-anchor");
        jq("html,body").animate({
            scrollTop: target.offset().top - jq("#header").height()
        }, "slow");
    });
}
/**
 * Balance Sheet Page - Income Statement Page - Cash Flow Page
 * 
 * Replaces <a> elements within report table with <span> elements.
 * Removes 'href' and 'onclick' attributes from these elements &
 * adds the original 'a' class back to it.
 */
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.report')) {
        // Find the table with class 'report'
        const reportTable = document.querySelector('.report');
        
        if (reportTable) {
            // Find all <td> elements containing <a> elements
            const tdWithLinks = reportTable.querySelectorAll('td a');
            
            // Transform each <a> into a <span>
            tdWithLinks.forEach(aElement => {
                const span = document.createElement('span');
                span.innerHTML = aElement.innerHTML;
                aElement.parentNode.replaceChild(span, aElement);
                span.classList.add("a");
            });
        }
    }
});

// Accesibility Form
let formCounter = 0;
jq('.add-request').accessibleClick(function(){
    formCounter++;
    let newFields = '<div class="info-block">' +
                	    '<div class="form-group">' +
                	        '<label for="url-'+ formCounter +'">URL of requested document or webpage:</label>' +
                	        '<input type="text" name="url-'+ formCounter +'" id="url-'+ formCounter +'" value="" class="required form-control" placeholder="ex. https://www.website.com/page" />' +
                	    '</div>' +
                	    '<div class="form-group">' +
                	        '<label for="description-'+ formCounter +'">Description of request or issue related to URL:</label>' +
                	       '<textarea name="description-'+ formCounter +'" id="description-'+ formCounter +'" value="" class="required form-control" placeholder="Enter a description of your request or issue related to the URL inputted above"></textarea>' +
                	    '</div>' +
            	    '</div>';
    jq('.request-info').append(newFields);
    jq('#url-' + formCounter).focus();
});

/**
 * Global Table Wrapper
 * 
 * If a table is too wide and moves off screen, this will add the "scroll" class
 * and shadow classes for accessibility.
 */
function applyScrollToTables() {
    jq('.table-figure').each(function() {
        let wrap = jq(this).closest('.table-wrapper');
        if (jq(this).find('table').outerWidth() > jq(this).outerWidth()) {
            wrap.addClass('scroll');
            wrap.addClass('shadow-right');
            let top = Math.round(jq(this).find('table').offset().top - wrap.offset().top);
            wrap.find('.left-shadow-block').css('top', top + 'px');
            wrap.find('.right-shadow-block').css('top', top + 'px');
        } else {
            wrap.removeClass('scroll');
            wrap.removeClass('shadow-right shadow-left')
        }
    });
}
/**
 * Global Table Wrapper - Update Shadows
 * 
 * This will update the "shadow" classes in the table wrapper
 * On load, the "shadow-right" class is in the table wrapper by default
 * If the user scrolls, it will add the "shadow-left shadow-right" classes
 * If the user scrolls all the way to the right, it will keep "shadow-left" but remove "shadow-right"
 */
function updateShadowsInTables() {
    jq(".scroll .table-figure").each(function() {
        let wrap = jq(this).closest('.table-wrapper');
        var cur = Math.ceil(jq(this).scrollLeft());
        var max = this.scrollWidth - jq(this).parent().width();

        if (cur == 0) {
            wrap.addClass('shadow-right').removeClass('shadow-left');
        } else if (cur >= max) {
            wrap.addClass('shadow-left').removeClass('shadow-right');
        } else {
            wrap.addClass('shadow-right shadow-left');
        }
    });
}
/**
 * Global - Decorative Image Alt Check
 * 
 * This will check all images across the site to see if the image has a
 * empty or missing alt attribute. If so, aria-hidden="true" will be set.
 */
jq('img').each((ind, el) => {
    // Check if the image has empty or no alt attribute
    if (!jq(el).attr('alt') || jq(el).attr('alt').trim() === '') {
        // If the alt text is empty or not present, set aria-hidden="true"
        jq(el).attr('aria-hidden', 'true');
    }
});

/**
 * Row Scripts
 * 
 * These are specific to rows in template
 */
 
// Row News Financial Results Event
jq(document).ready(function() {
    if (jq(".row-news-slider").length) {
       jq(".row-news-slider").slick(JSON.parse(document.getElementById("rowNewsSlickOptions").innerText));
       
        var sliderElement = jq('.row-news-slider');
        var progressBar = jq('.progress-bar-container .progress-bar');
    
        sliderElement.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            var calc = ( (nextSlide+1) / (slick.slideCount) ) * 100;
            
            progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc );
        });
    
        jq('.slick-prev').on('click', function() {
            sliderElement.slick('slickPrev');
        });
    
        jq('.slick-next').on('click', function() {
            sliderElement.slick('slickNext');
        });
    }
});

/**
 * Footnotes Functionality
 */
const createSuperscriptLink = (id) => `<a href="#footnoteDesc${id}" aria-describedby="footnoteDesc${id}" tabindex="0" data-footnote="${id}" class="span-asterisk"><sup>*</sup></a>`;
let footnoteCounter = 0;
function processFootnotesInSection(stats, footnotes) {
    // Processing of footnotes
    footnotes.forEach(footnote => {
        if (footnote.textContent.trim().startsWith('*')) {
            footnote.outerHTML = `<p id="footnoteDesc${++footnoteCounter}" class="footnote-desc" aria-label="Footnote ${footnoteCounter}" role="status" tabindex="0">${footnote.innerHTML}</p>`;
        }
    });
    // Link asterisks in stats to footnotes
    stats.forEach(stat => {
        let localCounter = footnoteCounter - 1;
        stat.innerHTML = stat.innerHTML.replace(/\*/g, () => createSuperscriptLink(++localCounter));
    });
}
function processAllFootnotes() {
    const sections = document.querySelectorAll('.container');
    sections.forEach(section => {
        const stats = section.querySelectorAll('.stat p, .stat-box p');
        const footnotes = section.querySelectorAll('.financial-disclaimer .financial-text p, .source p');
        processFootnotesInSection(stats, footnotes);
    });
}
document.addEventListener('DOMContentLoaded', processAllFootnotes);

// Email alerts accordion button: scroll to reveal the form when expanding
var emailAlertsBtn = document.querySelector('.btn[href="#email-alerts-cta-form"]');
if (emailAlertsBtn) {
    emailAlertsBtn.addEventListener('click', function() {
        if (this.getAttribute('aria-expanded') === 'false') {
            var header = document.getElementById('header');
            var navHeight = (header ? header.offsetHeight : 0) + 20;
            var buttonTop = this.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: buttonTop - navHeight,
                behavior: 'smooth'
            });
        }
    });
}

/**
 * Enables keyboard activation of CTA Email Alert buttons.
 * Works with both space and enter keys.
 */
document.addEventListener('DOMContentLoaded', function () {
    var links = document.querySelectorAll('a.email-alerts-btn');
    for (var i = 0; i < links.length; i++) {
        links[i].addEventListener('keydown', function (event) {
            if (event.key === ' ' || event.key === 'Spacebar') {
                event.preventDefault();
                this.click();
            }
        });
    }
});

/**
 * Adjusts the scroll position to ensure the focused element is visible within the viewport.
 *
 * The function checks if the element is above the visible area or below the viewport,
 * and if so, it adjusts the scroll position to bring the element into view with extra space.
 */
function adjustScrollPosition(e) {
    const headerHeight = document.querySelector("#header").offsetHeight;
    const extraSpace = 80;
    const totalHeight = headerHeight + extraSpace;
    const elementTop = e.target.getBoundingClientRect().top;
    const elementBottom = e.target.getBoundingClientRect().bottom;

    let is_affixed = jq(e.target).closest(".affix").length;

    if (!is_affixed && (elementTop < totalHeight || elementBottom > window.innerHeight)) {
        window.scrollTo({
            top: elementTop + window.scrollY - totalHeight,
            behavior: "smooth",
        });
    }
}

document.addEventListener("keydown", (e) => {
    if (e.key === "Tab" && e.shiftKey) {
        document.addEventListener("focusin", adjustScrollPosition);
    } else {
        document.removeEventListener("focusin", adjustScrollPosition);
    }
});

/**
 * Enables keyboard navigation for tabs within a .tab-header element.
 *
 * Key Features:
 * - Navigation wraps around when reaching the first or last tab.
 * - Focus is moved to the new tab, and the `click` event is triggered to activate it.
 * - Prevents default behavior for smoother keyboard interactions.
 */
document.addEventListener('keydown', (event) => {
    // Check if the focus is inside a .tab-header element
    const activeTab = document.activeElement.closest('.tab-header .nav-link');
    if (!activeTab) return;

    const tabHeader = activeTab.closest('.tab-header');
    const tabs = Array.from(tabHeader.querySelectorAll('.nav-link'));
    const currentIndex = tabs.indexOf(activeTab);

    let newIndex = -1;

    if (event.key === 'ArrowRight') {
        // Move to the next tab
        newIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft') {
        // Move to the previous tab
        newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } 

    if (newIndex >= 0) {
        event.preventDefault();
        // Activate the new tab
        const newTab = tabs[newIndex];
        newTab.focus();
        newTab.click();
    }
});